import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/freebies/[slug]/components/FreebieDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/ClientFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/PublicHeader.tsx");
